import * as Parallax from 'parallax-js/src/parallax';
import { Api } from '../../providers/api';
import { Booking } from '../../entities/booking';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { Config } from '../../entities/config';
import { DashboardPage } from '../dashboard/dashboard';
import { IonicPage, NavController, Slides } from 'ionic-angular';
import { LoginPage } from '../auth/login/login';
import { Shared } from '../../providers/shared';
import { SpinnerDialog } from '@ionic-native/spinner-dialog';

@IonicPage()
@Component({
    selector: 'page-intro',
    templateUrl: 'intro.html',
})
export class IntroPage {

    @ViewChild(Slides) slides: Slides;
    @ViewChild('parallax') parallaxSlide: ElementRef;

    constructor(
        private api: Api,
        private navCtrl: NavController,
        private shared: Shared,
        private spinner: SpinnerDialog,
    ) {
    }

    ionViewDidEnter() {
        if (this.parallaxSlide !== undefined)
            new Parallax(this.parallaxSlide.nativeElement);
    }

    slideChanged() {
        if (this.slides.getActiveIndex() === 3)
            this.saveAndExit();
    }

    async nextSlide() {
        if (this.slides.isEnd()) {
            await this.saveAndExit();
            return;
        }
        this.slides.slideNext();
    }

    async saveAndExit() {
        this.spinner.show();
        await this.shared.setAndStore('showIntro', true);
        let apiToken: Config = await this.shared.getConfig('apiToken');
        this.spinner.hide();

        if (apiToken === undefined || apiToken.value.length < 1)
            this.navCtrl.setRoot(LoginPage, {}, {animate: true, direction: 'forward'});
        else {
            let bookings: Booking[] = await this.api.getMyBookings();
            this.navCtrl.setRoot(DashboardPage, {bookings: bookings}, {animate: true, direction: 'forward'});
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/intro/intro.ts